import styled from "styled-components";

export default function BannerRecupera(){
    return(
        <Content>
            <a href="https://spcrecupera.com.br/"><img src="/img/banner-recupera.png" alt="" /></a>
        </Content>
    )
}

const Content = styled.main`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    
    margin: 20px 0;

    a{
        width: 80%;
    }

    img{
        width: 100%;
        border-radius: 20px;

        :hover{
            cursor: pointer;
        }
    }
`